export enum SimphonyPayloadField {
  CUSTOMER_NAME = 'customer_name',
  CUSTOMER_PHONE = 'customer_phone',
  ORDER_DATE = 'order_date',
  CHECK_NAME = 'check_name',
  TABLE = 'table',
}
